module.exports = __webpack_public_path__ + "933c3c8bb8fa7be99d3dc1695acdbfe3.png";